import Swiper from "swiper";

export default {
    data() {
        return {
            count: 0,
            bannerList: [],
            activeList: [],
            p: 1
        }
    },

    watch: {

    },

    created() {
        this.getBanner();
        this.getActiveList();
    },

    mounted() {
        setTimeout(() => {
            new Swiper('.swiper-container',{
                autoplay: {
                    delay: 3000
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    bulletElement : 'li',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
        },800)
    },

    methods: {
        // 获取轮播
        getBanner() {
            this.$post('api.php/Home/activityCarousel').then(res => {
                if(res.status == 1) {
                    this.bannerList = res.data || []
                }
            })
        },

        openPage(item) {
            console.log(item);
            // return;
            if(item.type === 1) {
                window.open(item.href)
            }else if(item.type === 2) {
                window.open(this._link + 'news/detail?id=' + item.link_id)
            }else if(item.type === 3) {
                // item.type = 2;
                window.open(this._link + 'active/detail?id=' + item.link_id + '&type=2')
            }else if(item.type === 5) {
                // item.type = 1;
                window.open(this._link + 'active/detail?id=' + item.link_id + '&type=1')
            }else {
                window.open(this._link + 'topic/detail?id=' + item.link_id)
            }
        },

        changePage(e) {
            this.p = e;
            this.getActiveList()
        },

        getActiveList() {
            const loading = this.$loading({
                text: '加载中...'
            })
            this.$post('api.php/Home/activityList',{
                p: this.p
            }).then(res => {
                if(res.status == 1) {
                    this.activeList = res.data.list || [];
                    this.count = res.data.count || 0;
                }
            }).finally(() => {
                loading.close();
            })
        }
    }
}
